import { Segmented, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";

const ViewWorkingDays = ({ fullData }: any) => {
  const [selectedDays, setSelectedDays] = useState<any>([]);
  useEffect(() => {
    if (fullData) {
      const selected =
        fullData?.calendarWorkingDays?.map((day: any) => day.dayName) || [];
      setSelectedDays(selected);
    }
  }, [fullData]);
  const daysMaster = [
    { dayId: 1, dayName: "Sunday" },
    { dayId: 2, dayName: "Monday" },
    { dayId: 3, dayName: "Tuesday" },
    { dayId: 4, dayName: "Wednesday" },
    { dayId: 5, dayName: "Thursday" },
    { dayId: 6, dayName: "Friday" },
    { dayId: 7, dayName: "Saturday" },
  ];
  return (
    <>
      <div className="mt-3">
        {/* <div className="data-col align-center pt-1"> */}
        <label className="mb-2" style={{ color: "black", fontWeight: 500 }}>
          {/* <h5 className="w-100 d-flex  align-items-center"> */}
          Working Days :{/* </h5> */}
        </label>
        <Segmented
          options={daysMaster.map((day) => ({
            label: <span>{day.dayName}</span>,
            value: day.dayName,
            className: selectedDays.includes(day.dayName)
              ? "view-selected-segment"
              : "view-unselected-segment",
          }))}
          value={selectedDays}
          block
          multiple
          disabled={true}
        />
      </div>
      <div className="mt-4">
        {/* <div className="data-col align-center pt-1"> */}
        <label className="mb-2" style={{ color: "black", fontWeight: 500 }}>
          {/* <h5 className="w-100 d-flex  align-items-center"> */}
          Shift Timings :{/* </h5> */}
        </label>
        <Table
          columns={[
            {
              title: "Shift Name",
              dataIndex: "shiftName",
              key: "shiftName",
            },
            {
              title: "Shift Type",
              dataIndex: "shiftType",
              key: "shiftType",
            },
            {
              title: "Start Time",
              dataIndex: "shiftStartTime",
              key: "shiftStartTime",
            },
            {
              title: "End Time",
              dataIndex: "shiftEndTime",
              key: "shiftEndTime",
            },
          ]}
          dataSource={fullData?.calendarShifts}
          bordered
          size="middle"
          scroll={{
            x: 1100,
          }}
        />
      </div>
    </>
  );
};

export default ViewWorkingDays;
